import React, { useState } from "react";
import { Grid, makeStyles } from "@material-ui/core";

import { Icon, Modal } from "../../components/base";
import ShareIcon from "../../assets/images/icons/share.svg";
import ExportToFileIcon from "../../assets/images/icons/export-to-file.svg";
import IntegrateIcon from "../../assets/images/icons/integrate.svg";
import { ExportDataModal, ShareBoardModal, IntegrateAppModal } from "../../components/modals";

const useStyles = makeStyles((theme) => ({
  groupIcons: {
    width: "fit-content",
    marginLeft: "auto",
    height: "fit-content",
  },
  iconButton: {
    marginLeft: theme.spacing(2),
  },
}));

const MODALS = {
  export: 0,
  shareBoard: 1,
  integrateApps: 2,
};

const modals = [ExportDataModal, ShareBoardModal, IntegrateAppModal];

const ModalMainContent = React.forwardRef((props, ref) => {
  const { modal } = props;
  const ModalContent = modals[modal];

  return <ModalContent {...props} forwardRef={ref} />
})

export const ActionButtonsGroup = ({
  hideShareBtn,
  hideExportBtn,
  hideIntegrateBtn,
}) => {
  const classes = useStyles();
  const [modal, setModal] = useState(null);

  return (
    <>
      <Grid className={classes.groupIcons} container>
        {!hideShareBtn && (
          <Icon
            root={classes.iconButton}
            src={ShareIcon}
            hoverable
            tooltip="Share"
            onClick={() => setModal(MODALS.shareBoard)}
          />
        )}
        {!hideExportBtn && (
          <Icon
            root={classes.iconButton}
            src={ExportToFileIcon}
            hoverable
            tooltip="Export"
            onClick={() => setModal(MODALS.export)}
          />
        )}
        {!hideIntegrateBtn && (
          <Icon
            root={classes.iconButton}
            src={IntegrateIcon}
            hoverable
            tooltip="Integrate"
            onClick={() => setModal(MODALS.integrateApps)}
          />
        )}
      </Grid>

      <Modal open={modal !== null} onClose={() => setModal(null)}>
        {modal !== null ? <ModalMainContent modal={modal} onClose={() => setModal(null)} /> : <div></div> }
      </Modal>
    </>
  );
};
